module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    attrs: {
      "i": "jd-city-comp"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "yd-mask jd-mask",
    class: {
      'mask-show': _vm.show
    },
    on: {
      "click": function($event) {
        return _vm.close()
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-cityselect brouce-in",
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "cityselect-header"
  }, [_c('p', {
    staticClass: "cityselect-title"
  }, [_vm._v("请选择省市区")]), _vm._v(" "), _c('div', {
    staticClass: "cityselect-nav"
  }, [_c('a', {
    class: {
      crt: _vm.now_idx == 0
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.now_idx = 0;
        _vm.showNext = 0;
      }
    }
  }, [_vm._v(_vm._s(_vm.province_name ? _vm.province_name : '请选择'))]), _vm._v(" "), _c('a', {
    class: {
      crt: _vm.now_idx == 1
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.now_idx = 1;
        _vm.showNext = 1;
      }
    }
  }, [_vm._v(_vm._s(_vm.city_name))]), _vm._v(" "), _c('a', {
    class: {
      crt: _vm.now_idx == 2
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.now_idx = 2;
        _vm.showNext = 2;
      }
    }
  }, [_vm._v(_vm._s(_vm.area_name))]), _vm._v(" "), _c('a', {
    class: {
      crt: _vm.now_idx == 3
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.now_idx = 3;
        _vm.showNext = 2;
      }
    }
  }, [_vm._v(_vm._s(_vm.town_name))])])]), _vm._v(" "), _c('ul', {
    staticClass: "cityselect-content cityselect-move-animate",
    class: {
      'cityselect-prev': _vm.showNext < 1, 'cityselect-next': _vm.showNext < 2, 'cityselect-last': _vm.showNext == 2
    }
  }, [_c('li', {
    staticClass: "cityselect-item"
  }, [_c('div', {
    staticClass: "cityselect-item-box"
  }, _vm._l((_vm.province), function(item, index) {
    return _c('a', {
      class: {
        crt: _vm.province_id == item.v
      },
      attrs: {
        "href": "javascript:;",
        "data-id": item.v
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index, 2)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.n))])])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "cityselect-item"
  }, [_c('div', {
    staticClass: "cityselect-item-box"
  }, _vm._l((_vm.city), function(item, index) {
    return _c('a', {
      class: {
        crt: _vm.city_id == item.v
      },
      attrs: {
        "href": "javascript:;",
        "data-id": item.v
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index, 3)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.n))])])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "cityselect-item"
  }, [_c('div', {
    staticClass: "cityselect-item-box"
  }, _vm._l((_vm.area), function(item, index) {
    return _c('a', {
      class: {
        crt: _vm.area_id == item.v
      },
      attrs: {
        "href": "javascript:;",
        "data-id": item.v
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index, 4, 1)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.n))])])
  }), 0)]), _vm._v(" "), _c('li', {
    staticClass: "cityselect-item"
  }, [_c('div', {
    staticClass: "cityselect-item-box"
  }, _vm._l((_vm.town), function(item, index) {
    return _c('a', {
      class: {
        crt: _vm.town_id == item.v
      },
      attrs: {
        "href": "javascript:;",
        "data-id": item.v
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(index, 5)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.n))])])
  }), 0)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02a6af2d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Jdcity.vue
// module id = 1818
// module chunks = 215